var _objectSpread = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var channelLib = require('./Channel');

var identityLib = require('./Identity');

var MerkleTree = require('./MerkleTree');

var splitSig = require('./splitSig');

module.exports = _objectSpread(_objectSpread(_objectSpread({}, channelLib), identityLib), {}, {
  MerkleTree: MerkleTree,
  splitSig: splitSig
});